/*
 * @Description: 文档管理or目录管理
 * @Autor: lwq
 * @Date: 2020-07-28 10:49:16
 * @LastEditors: betwaym 848032671@qq.com
 * @LastEditTime: 2023-11-29 16:11:42
 * @FilePath: \mrc-base-server-view\src\service\api\passwordIntensite.js
 */
//  文档管理or目录管理
import http from '../httpConfig'

const table = "ess_doc_directory"

// 获取文档目录树形列表
export const doc_tree = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/treeListAll/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 根据uuid获取文档列表
export const doc_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/documentAll/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 获取文档目录详情
export const doc_info = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/documentDirectoryInfo/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取文档目录移动弹框
export const doc_move_pop = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/directoryMovePopboxes/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 删除文档目录
export const doc_delete = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/delDocumentDirectory/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 移动文档目录
export const doc_update_move = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/mobileDirectory/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 修改文档目录名称
export const doc_update_name = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/upDocumentDirectoryName/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
//新增文档目录
export const doc_add = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/addDocumentDirectory/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//文档重复名
export const doc_rename = (params = {}) => {
  params['~table~'] = 'ess_doc_org_document'
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/upDocumentName/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 上传文件
export const doc_upload = (params = {}) => {
  params['~table~'] = 'ess_doc_org_document'
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/uploadDocument/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 移动文件
export const doc_move = (params = {}) => {
  params['~table~'] = 'ess_doc_directory'
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/fileMoveTo/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
//下载文件
export const doc_download = (params = {}) => {
  params['~table~'] = 'ess_doc_org_document'
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/downloadDocument/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
//删除文件本身
export const doc_delete_file = (params = {}) => {
  params['~table~'] = 'ess_doc_org_document'
  return new Promise((resolve, reject) => {
    http.post('/api/ess/doc/admin/delDocument/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
